import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import { AlertCircle } from 'lucide-react'

interface CardWarningPanelProps {
  message: string
  className?: string
  textClassName?: string
  inlineActionLabel?: string
  onInlineActionClick?: () => void
}

export function CardWarningPanel({
  message,
  className,
  textClassName,
  inlineActionLabel,
  onInlineActionClick,
}: CardWarningPanelProps) {
  const inlineActionParts =
    inlineActionLabel && onInlineActionClick ? message.split(inlineActionLabel, 2) : null
  const hasInlineAction = !!inlineActionParts && inlineActionParts.length === 2

  return (
    <div className={cn('rounded-lg border border-red-500/20 bg-red-500/10 p-3', className)}>
      <div className="flex items-start gap-2">
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
        {hasInlineAction ? (
          <Typography variant="p" className={cn('text-red-400 text-sm', textClassName)}>
            {inlineActionParts![0]}
            <button
              type="button"
              onClick={onInlineActionClick}
              className="font-medium underline underline-offset-2 transition-colors hover:text-red-200"
            >
              {inlineActionLabel}
            </button>
            {inlineActionParts![1]}
          </Typography>
        ) : (
          <Typography variant="p" className={cn('text-red-400 text-sm', textClassName)}>
            {message}
          </Typography>
        )}
      </div>
    </div>
  )
}
